export const getAbsoluteGuideIndex = (categories, activeCategoryIndex, activeGuideIndex) => categories
    .slice(0, activeCategoryIndex)
    .reduce((acc, category) => acc + category.guides.length, 0) + activeGuideIndex;
